import React from "react";

const GuestFeatures = () => {
  const stopWatchIcon = require("../images/stopwatch.svg");
  const smartphoneIcon = require("../images/smartphone.svg");
  const searchIcon = require("../images/search.svg");
  const commentIcon = require("../images/comment.svg");

  return (
    <section className="bg-white py-8">
      <div className="container max-w-5xl mx-auto m-8">
        <h2 className="w-full my-2 text-5xl font-bold leading-tight text-center text-gray-800">
          Deine Vorteile
        </h2>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto gradient w-64 opacity-25 my-0 py-0 rounded-t" />
        </div>

        <div className="flex flex-wrap my-20">
          <div className="w-5/6 sm:w-1/2 p-6">
            <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
              Du bist im Lokal, bleibst aber gesundheitsbewusst lieber auf
              Distanz?
            </h3>
            <p className="text-gray-600 mb-8">
              Verschmutzte oder nicht verfügbare Speisekarte? Gibt’s nicht!
            </p>
            <p className="text-gray-600 mb-8">
              Mit getsby funktioniert das Bestellen und Bezahlen über das
              Smartphone, also ohne direkten persönlichen Kontakt mit den
              Service-Mitarbeitern. Damit lässt sich eine mögliche
              Ansteckungsgefahr vermindern.
            </p>
          </div>
          <div className="w-full sm:w-1/2 p-6">
            <img
              src={require("./../images/protected.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
        </div>

        <div className="flex flex-wrap flex-col-reverse sm:flex-row my-20">
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <img
              src={require("./../images/bag.svg")}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <div className="align-middle">
              <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
                Du bevorzugst Take-Away?
              </h3>
              <p className="text-gray-600 mb-8">
                Mit getsby ist das Warten Geschichte!
              </p>
              <p className="text-gray-600 mb-8">
                Mit getsby bestellst du für Take-Away und holst Dein Essen erst
                ab, wenn es wirklich abholbereit ist!
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap my-20">
          <div className="w-5/6 sm:w-1/2 p-6">
            <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
              Du bist in Eile?
            </h3>
            <p className="text-gray-600 mb-8">
              Mit getsby sparst du wertvolle Zeit!
            </p>
            <p className="text-gray-600 mb-8">
              Mit getsby bezahlst du <b>jederzeit</b> per Klick. Stehst auf und
              gehst. Kein Warten bis die Rechnung kommt!
            </p>
          </div>
          <div className="w-full sm:w-1/2 p-6">
            <img
              src={stopWatchIcon}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
        </div>

        <div className="flex flex-wrap flex-col-reverse sm:flex-row my-20">
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <img
              src={smartphoneIcon}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <div className="align-middle">
              <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
                Geldtasche vergessen? Egal!
              </h3>
              <p className="text-gray-600 mb-8">
                Einfach elektronisch bezahlen mit getsby!
              </p>
              <p className="text-gray-600 mb-8">
                Selbst wenn das Lokal keine Kartenzahlung akzeptiert kannst du
                mit getsby elektronisch bezahlen. Auch Trinkgeld geben
                funktioniert ganz praktisch direkt in der App.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap my-20">
          <div className="w-5/6 sm:w-1/2 p-6">
            <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
              Gusto auf ein bestimmtes Gericht? Lust auf Nachtisch?
            </h3>
            <p className="text-gray-600 mb-8">Blick aufs Smartphone genügt!</p>
            <p className="text-gray-600 mb-8">
              Mit der getsby Suchfunktion findest du deine Lieblingsspeisen und
              -getränke – schnell und ohne langes Blättern! Außerdem erfährst du
              welche Produkte gerade nicht verfügbar sind.
            </p>
          </div>
          <div className="w-full sm:w-1/2 p-6">
            <img
              src={searchIcon}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
        </div>

        <div className="flex flex-wrap flex-col-reverse sm:flex-row my-20">
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <img
              src={commentIcon}
              width="150px"
              height="150px"
              className="m-auto"
              alt=""
            />
          </div>
          <div className="w-full sm:w-1/2 p-6 mt-6">
            <div className="align-middle">
              <h3 className="text-3xl text-gray-800 font-bold leading-none mb-3">
                Eine Zutat vermiest dir manche Gerichte?
              </h3>
              <p className="text-gray-600 mb-8">
                Mit der Kommentarfunktion in der getsby App ist das kein Problem
                mehr!
              </p>
              <p className="text-gray-600 mb-8">
                Egal ob Pizza ohne Schinken, oder Burger ohne Tomate – tippe
                einfach ins Handy, welche Zutaten du nicht willst. So wird deine
                Speisenauswahl größer und du genießt ganz individuell!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuestFeatures;
